import { AfterContentChecked, Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { ContentHeaderHTML, ContentHeaderKey, ContentHeaderTitle } from "src/app/constants/content-header";
import { SvgMatType } from "src/app/constants/icons";
import { BenefitWizardType } from "src/app/constants/wizard-panels";
import { EnrollmentManager } from "src/app/models/enrollment-manager";
import { ListItem } from "src/app/models/listItem";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-benefit-enrollment-category-header',
    templateUrl: './category-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenefitEnrollmentCategoryHeader implements OnInit, AfterContentChecked {
    @Input() public enrollmentManager: EnrollmentManager;

    public svgType = SvgMatType;
    public contentTitleMwp: string;
    public text: string;

    public currentCategoryName: string;
    public currentBenefitWizardType: string;
    public currentBenefitName: string;
    public currentBenefitAvailable: string;
    public title: string;
    public titleJsonKey: string;
    public headerHTML: string;
    public headerHTMLJsonKey: string;
    public displayStepper: boolean;
    public steppers: ListItem[];
    public disableStepper: boolean;
    public currentPanel: string;

    public enrollmentCategoryHeaderForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        public enrollmentManagerService: EnrollmentManagerService,
    ) {
        this.enrollmentManagerService.$EnrollmentStepper.subscribe((steps: ListItem[]) => {
            this.steppers = steps;
            this.currentPanel = this.enrollmentManagerService.benefitWizardControlPanel.panel;
            this.disableStepper = this.currentPanel == 'finalize' || this.currentPanel == 'Finalize';
            this.displayStepper = !!this.steppers;
        });
    }

    ngOnInit(): void {
        this.enrollmentCategoryHeaderForm = this.formBuilder.group({
            panel: [null, Validators.required],
        });

        this.currentCategoryName = this.enrollmentManager.selectedCategoryName;
        this.currentBenefitWizardType = this.enrollmentManager.BenefitWizardType;
        this.loadHeaderModel();
    }

    ngAfterContentChecked(): void {
        this.load();
    }

    private load(): void {
        if (this.currentCategoryName != this.enrollmentManager.selectedCategoryName) {
            this.currentCategoryName = this.enrollmentManager.selectedCategoryName;
            this.currentBenefitWizardType =
                this.enrollmentManager.BenefitWizardType =
                this.currentBenefitName = null;
            this.enrollmentManager.selectedBenefitName = null;
        }

        if (this.currentBenefitWizardType != this.enrollmentManager.BenefitWizardType) {
            this.currentBenefitName = null;
            this.enrollmentManager.selectedBenefitName = null;
            this.currentBenefitWizardType = this.enrollmentManager.BenefitWizardType;
        }

        if (this.currentBenefitName != this.enrollmentManager.selectedBenefitName) {
            this.currentBenefitName = this.enrollmentManager.selectedBenefitName;
            this.currentBenefitAvailable = this.enrollmentManager.selectedBenefitAvailable;
        }

        this.loadHeaderModel();
    }

    private loadHeaderModel(): void {
        this.resetHeader();

        let l_ContentHeaderKey: ContentHeaderKey;
        if (this.currentBenefitWizardType) {

            switch (this.currentBenefitWizardType) {
                case BenefitWizardType.Add:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXAddBenefit;
                    break;

                case BenefitWizardType.BuyUp:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXModifyBenefit;
                    break;

                case BenefitWizardType.Cancel:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXCancelRequest;
                    break;

                case BenefitWizardType.WaiveBenefit:
                case BenefitWizardType.Waive:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXWaiveBenefit;
                    break;

                case BenefitWizardType.Term:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXWaiveBenefit;
                    break;

                case BenefitWizardType.FSA:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXFsaReenroll;
                    break;

                case BenefitWizardType.Widget:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXWidget;
                    break;

                case BenefitWizardType.Checkout:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardCheckout;
                    break;

                case BenefitWizardType.Keep:
                    l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardXKeepCurrentElections;
                    break;
            }
        }

        if (!l_ContentHeaderKey && this.enrollmentManager.selectedCategoryId == this.enrollmentManagerService.checkoutItem.id)
            l_ContentHeaderKey = ContentHeaderKey.EnrollmentDashboardCheckout;

        if (l_ContentHeaderKey) {
            this.titleJsonKey = 'contentHeader' + l_ContentHeaderKey;
            this.title = ContentHeaderTitle[this.titleJsonKey as keyof typeof ContentHeaderTitle];
            this.headerHTMLJsonKey = 'contentHeaderHTML' + l_ContentHeaderKey;
            this.headerHTML = ContentHeaderHTML[this.headerHTMLJsonKey as keyof typeof ContentHeaderHTML];
        }
    }

    private resetHeader(): void {
        this.titleJsonKey =
            this.title =
            this.headerHTMLJsonKey =
            this.headerHTML = null;
    }

    public onStepChange(event: MatOptionSelectionChange): void {
        if (event.isUserInput && event.source.value != this.currentPanel) {
            this.enrollmentManagerService.changeStep(event.source.value);
        }
    }
}
